import styled from 'styled-components';

import Media from '../../../assets/styles/media';

export const PageContent = styled.div`
  width: 100%;
`;

export const PageCtn = styled.div`
  display: flex;
  padding-bottom: 80px;

  ${Media.Below.mobileLarge`
    flex-direction: column;
  `}
`;

export const LeftSpacer = styled.div`
  min-width: 240px;

  ${Media.Below.desktop`
    min-width: 70px;
    width: 70px;
  `}

  ${Media.Below.mobileLarge`
    min-width: 0px;
    width: 0px;
    height: 110px;
  `}
`;
